import { Helmet } from 'react-helmet-async';
import CandidateListView from 'src/sections/candidates/view/candidates-list-view';
// ----------------------------------------------------------------------

export default function CandidateListPage() {
  return (
    <>
      <Helmet>
        <title>Hireintel - Dashboard - Hire Smartly</title>
      </Helmet>

      <CandidateListView />
    </>
  );
}
